import { render, staticRenderFns } from "./Samplingpoints.vue?vue&type=template&id=3edb2fee&"
import script from "./Samplingpoints.vue?vue&type=script&lang=js&"
export * from "./Samplingpoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports